import { installKarrotBridgeDriver, makeKarrotBridge } from '@daangn/karrotbridge'

export function isValidKarrotBridgeDriver(driver) {
  return Boolean(
    driver &&
      typeof driver.getCurrentEnvironment === 'function' &&
      typeof driver.onQueried === 'function' &&
      typeof driver.onSubscribed === 'function' &&
      typeof driver.postMessage === 'function'
  )
}

export function isKarrotBridgeAvailable(karrotBridge) {
  if (typeof window === 'undefined') {
    return false
  }

  const bridge = karrotBridge || window.karrotBridge

  if (!bridge || !bridge.driver || typeof bridge.driver.getCurrentEnvironment !== 'function') {
    return false
  }

  let env
  try {
    env = bridge.driver.getCurrentEnvironment()
  } catch (error) {
    return false
  }

  if (env === 'Android') {
    return typeof window.AndroidFunction?.messageHandler === 'function'
  }

  if (env === 'Cupertino') {
    return typeof window.webkit?.messageHandlers?.messageHandler?.postMessage === 'function'
  }

  return false
}

export function ensureKarrotBridge() {
  if (typeof window === 'undefined') {
    return null
  }

  if (window.karrotBridge) {
    window.supportKarrotBridge = isKarrotBridgeAvailable(window.karrotBridge)
    return window.karrotBridge
  }

  let driver = null
  if (isValidKarrotBridgeDriver(window.native)) {
    driver = window.native
  } else if (!window.native) {
    try {
      const installed = installKarrotBridgeDriver()
      driver = installed?.driver
    } catch (error) {
      driver = null
    }
  }

  if (driver) {
    window.karrotBridge = makeKarrotBridge({ driver })
  }

  window.supportKarrotBridge = isKarrotBridgeAvailable(window.karrotBridge)
  return window.karrotBridge
}

export function callKarrotBridgeSafely(action, { fallback } = {}) {
  if (!isKarrotBridgeAvailable()) {
    if (typeof fallback === 'function') {
      fallback()
    }
    return false
  }

  try {
    action(window.karrotBridge)
    return true
  } catch (error) {
    if (typeof fallback === 'function') {
      fallback(error)
    }
    return false
  }
}
